/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: SectionContainer.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  05.07.22 2:17 pm.
 * Last modified: 05.07.22 2:17 pm.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';
import { SEARCH_SECTION_NAME } from '../constants';
import { useSettings } from '../contexts/SettingsContext';

const SectionContainer = React.forwardRef<HTMLDivElement, ISectionContainerProps>(
    ({ children }: ISectionContainerProps, ref) => {
        const [settings] = useSettings();

        return (
            <div
                className={`egt_section_container egt_section_container_${
                    settings.mode
                } egt_section_container_${(settings.isSearchOpen
                    ? SEARCH_SECTION_NAME
                    : settings.selectedSection
                ).toLowerCase()}`}
                ref={ref}
            >
                {children}
            </div>
        );
    },
);

interface ISectionContainerProps {
    children?: React.ReactNode;
}

export default SectionContainer;
